import { render, staticRenderFns } from "./RecursosList.vue?vue&type=template&id=e153f346&"
import script from "./RecursosList.vue?vue&type=script&lang=js&"
export * from "./RecursosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports